import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { APP_NAME } from "../../utils/constants";

const Navbar = () => {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const displayName = user?.Name || user?.UserName || user?.Email || "Promoter";
  const initials = displayName.charAt(0).toUpperCase();

  return (
    <header style={styles.navbar}>
      {/* Brand */}
      <div style={styles.brandWrap}>
        <img src="/PS_favicon.png" alt="PS" style={styles.brandIcon} />
        <span style={styles.brand}>{APP_NAME}</span>
      </div>

      {/* Right: avatar + dropdown */}
      <div ref={menuRef} style={styles.right}>
        <button
          style={styles.avatarBtn}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="User menu"
        >
          <span style={styles.avatar}>{initials}</span>
          <span style={styles.displayName}>{displayName}</span>
          <span style={styles.caret}>{menuOpen ? "▲" : "▼"}</span>
        </button>

        {menuOpen && (
          <div style={styles.dropdown}>
            <div style={styles.dropdownHeader}>
              <span style={styles.dropdownName}>{displayName}</span>
              {user?.Email && <span style={styles.dropdownEmail}>{user.Email}</span>}
            </div>
            <div style={styles.divider} />
            <button style={styles.dropdownItem} onClick={logout}>
              <span style={{ marginRight: 8 }}>🚪</span> Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

const styles = {
  navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 56,
    padding: "0 24px",
    background: "#1e1e2d",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  brandWrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  brandIcon: {
    width: 28,
    height: 28,
    borderRadius: 6,
  },
  brand: {
    fontWeight: 700,
    fontSize: 17,
    color: "#fff",
    letterSpacing: 0.3,
  },
  right: {
    position: "relative",
  },
  avatarBtn: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 8,
    padding: "6px 12px",
    cursor: "pointer",
    color: "#fff",
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "#6c63ff",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 13,
    flexShrink: 0,
  },
  displayName: {
    fontSize: 13,
    fontWeight: 500,
    color: "#d1d5db",
    maxWidth: 140,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  caret: {
    fontSize: 9,
    color: "#9ca3af",
  },
  dropdown: {
    position: "absolute",
    top: "calc(100% + 8px)",
    right: 0,
    width: 220,
    background: "#fff",
    borderRadius: 10,
    boxShadow: "0 8px 30px rgba(0,0,0,0.18)",
    overflow: "hidden",
    zIndex: 200,
  },
  dropdownHeader: {
    padding: "14px 16px 10px",
  },
  dropdownName: {
    display: "block",
    fontWeight: 600,
    fontSize: 14,
    color: "#1e1e2d",
  },
  dropdownEmail: {
    display: "block",
    fontSize: 12,
    color: "#888",
    marginTop: 2,
  },
  divider: {
    height: 1,
    background: "#f0f0f0",
  },
  dropdownItem: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    background: "transparent",
    border: "none",
    fontSize: 14,
    color: "#e53935",
    fontWeight: 500,
    cursor: "pointer",
    textAlign: "left",
  },
};

export default Navbar;
